<template>
  <div>
    <modal-backdrop-inline v-if="options.backdrop && options.inlineBackdrop && show"></modal-backdrop-inline>
    <div ref="dialog" role="dialog" :class="{modal: true, fade: fadeEffect, zoom: zoomEffect, 'no-close-icon': !showHeaderCloseButton}">
      <div role="document"
        :class="{'modal-dialog': true, 'modal-lg': largeModal, 'modal-sm': smallModal}"
        :style="{width: optionalWidth}"
        >
        <div class="modal-content">
          <slot name="modal-header">
            <div class="modal-header">
              <button type="button" class="close" @click="close"><span>&times;</span></button>
              <h4 class="modal-title">
                <slot name="title">{{ title }}</slot>
              </h4>
            </div><!-- .modal-header -->
          </slot>
          <slot name="modal-body">
            <div class="modal-body">
              <slot name="content">
                {{ content }}
              </slot>
            </div><!-- .modal-body -->
          </slot>
          <slot name="modal-footer">
            <div class="modal-footer">
              <slot name="buttons-left" class="pull-left"></slot>
              <slot name="buttons">
                <button
                  class="btn btn-primary"
                  ref="okBtn"
                  type="button"
                  @click="_handleOkBtnClick"
                  >
                  {{ okText }}
                </button>
                <button
                  class="btn btn-default"
                  ref="cancelBtn"
                  type="button"
                  @click="close"
                  >
                  {{ cancelText }}
                </button>
              </slot>
            </div><!-- .modal-footer -->
          </slot>
        </div><!-- .modal-content -->
      </div><!-- .modal-dialog -->
    </div><!-- .dialog -->
  </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import ModalBackdropInline from '@/plugin/bootstrap/modal-backdrop-inline';

export default {
  name: 'modal',
  props: {
    okText: {
      type: String,
      default: 'OK'
    },
    cancelText: {
      type: String,
      default: 'Cancel'
    },
    title: {
      type: String,
      default: 'Modal'
    },
    content: {
      type: String,
      default: 'Content'
    },
    backdrop: {
      type: Boolean,
      default: true
    },
    staticBackdrop: {
      type: Boolean,
      default: false
    },
    inlineBackdrop: {
      type: Boolean,
      default: false
    },
    effect: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: null
    },
    width: {
      type: Number,
      default: null
    },
    show: {
      required: true,
      type: Boolean,
      default: false
    },
    // Bootstrap modal has keyboard option that enables or disable the ability
    // to close the dialog box via ESC key.  But problem with that feature is
    // there's no way for the internal component to override that and if the
    // keyboard option is set to true that pressing ESC will always close the
    // dialog box even when sometimes ESC is needed by an input and event must
    // not traverse which is not what is wanted.
    // This is a workaround that issue and it manually captures the ESC event
    // and handled accordingly.
    closeOnEsc: {
      required: false,
      type: Boolean,
      default: true
    },
    callback: {
      type: Function,
      default: null
    },
    contextId: {
      type: String,
      default: null
    },
    showHeaderCloseButton: {
      type: Boolean,
      default: true
    },
    autoFocusOkBtn: {
      type: Boolean,
      default: false
    },
    autoFocusCancelBtn: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      options: {
        backdrop:       this.backdrop,
        staticBackdrop: this.staticBackdrop,
        inlineBackdrop: this.inlineBackdrop,
        title:          this.title
      },
      visible: false
    }
  },
  computed: {
    fadeEffect() {
      return 'fade' === this.effect
    },
    zoomEffect() {
      return 'zoom' === this.effect
    },
    largeModal() {
      return 'large' === this.size
    },
    smallModal() {
      return 'small' === this.size
    },
    optionalWidth() {
      if (null === this.width) {
        return null;
      } else if (Number.isInteger(this.width)) {
        return `${this.width}px`
      }

      return this.width
    }
  },
  watch: {
    show(val) {
      if (val) {
        if (!this.visible) {
          this._showModal();
        }
      } else {
        if (this.visible) {
          this._hideModal();
        }
      }
    },
    backdrop(val) {
      this._setBackdrop(val)
      $(this._el()).data('modal').options.backdrop = this._determineBackdrop()
    },
    staticBackdrop(val) {
      this._setStaticBackdrop(val)
      $(this._el()).data('modal').options.staticBackdrop = this._determineStaticBackdrop()
    },
    inlineBackdrop(val) {
      this._setInlineBackdrop(val)
      $(this._el()).data('modal').options.backdrop = this._determineBackdrop()
      $(this._el()).data('modal').options.staticBackdrop = this._determineStaticBackdrop()
    },
    closeOnEsc(val) {
      if (val) {
        this._createCloseOnEscListener()
      } else {
        this._destroyCloseOnEscListener()
      }
    }
  },
  methods: {
    close() {
      this._hideModal()
      this._destroyCloseOnEscListener()
    },
    _setBackdrop(val) {
      this.options.backdrop = val
    },
    _setStaticBackdrop(val) {
      this.options.staticBackdrop = val
    },
    _setInlineBackdrop(val) {
      this.options.inlineBackdrop = val
    },
    _showModal() {
      $(this._el()).modal('show')
    },
    _hideModal() {
      $(this._el()).modal('hide')
    },
    _handleOnEsc(e) {
      if (27 === e.keyCode) {
        this._hideModal()
      }
    },
    _handleOkBtnClick() {
      if (null === this.callback) {
        this.close()
      } else if ('function' === typeof this.callback) {
        this.callback()
      }
    },
    _determineBackdrop() {
      return this.options.backdrop && true !== this.options.inlineBackdrop
    },
    _determineStaticBackdrop() {
      return this.options.staticBackdrop ? 'static' : true
    },
    _applyFocusOnOkButton() {
      if (!_.has(this.$refs, 'okBtn')) {
        return
      }
      this.$refs.okBtn.focus()
    },
    _applyFocusOnCancelButton() {
      if (!_.has(this.$refs, 'cancelBtn')) {
        return
      }
      this.$refs.cancelBtn.focus()
    },
    _el() {
      return this.$refs.dialog
    },
    _createCloseOnEscListener() {
      document.addEventListener('keyup', this._handleOnEsc)
    },
    _destroyCloseOnEscListener() {
      document.removeEventListener('keyup', this._handleOnEsc)
    },
  },
  components: {
    ModalBackdropInline
  },
  mounted() {
    const el = this._el()

    $(el).modal({
      backdrop: this._determineBackdrop() ? (this._determineStaticBackdrop()) : false,
      show: false,
      // functionality is replaced by prop closeOnEsc.  See the prop for details.
      keyboard: false
    })
    .on('show.bs.modal', () => {
      this.$emit('show')
    })
    .on('shown.bs.modal', () => {
      this.visible = true
      this.$emit('shown')
    })
    .on('hide.bs.modal', () => {
      this.$emit('close')
    })
    .on('hidden.bs.modal', () => {
      this.visible = false
      this.$emit('closed')
    })

    if (this.closeOnEsc) {
      this._createCloseOnEscListener()
    } else {
      this._destroyCloseOnEscListener()
    }

    if (this.show) {
      this._showModal()
    }

    el.focus()

    if (this.autoFocusOkBtn) {
      this._applyFocusOnOkButton()
    } else if (this.autoFocusCancelBtn) {
      this._applyFocusOnCancelButton()
    }
  },
  destroyed() {
    this._destroyCloseOnEscListener()
    $(this._el()).modal('hide')
  }
}
</script>

<style lang="scss">
.modal.no-close-icon .modal-header .close {
  display: none;
}
</style>
